import React, { useRef } from 'react';
import { useState, useEffect } from 'react';
import { addComma } from '../../lib/common';

interface Props {
  newNum?: number;
  needComma?: boolean;
  needZero?: boolean;
}

function CountNumber({ newNum = 0, needComma = false, needZero = false }: Props): JSX.Element {
  // const helperNum: number = Math.sign(newNum) > -1 ? newNum : -newNum;
  const [helperNum, setHelperNum] = useState<number>(0);
  const [countNum, setCountNum] = useState<number>(0);
  const numRef = useRef<number>(0);

  useEffect(() => {
    setHelperNum(Math.sign(newNum) > -1 ? newNum : -newNum);
  }, [newNum]);

  useEffect(() => {
    /* 새로 받아온 값이 있으면 count 시작 */
    if (helperNum !== numRef.current || helperNum === 0) {
      const processCount = () => {
        /* 반복속도 */
        const duration: number = 8;
        /* 증감 비율(%) */
        const rate: number = 0.025;
        /* 증감값 */
        let rateAmount: number = helperNum * rate;

        // console.log('받은 숫자 => ', helperNum, '\n증감값 => ', rateAmount, '\n기존 숫자 => ', countNum);

        let calcNum: number = numRef.current;
        if (calcNum !== countNum) {
          /*
            해당 구문은 새로운 숫자를 받을 때 마다 0에서 부터 시작하는 게 아니라 현재의 번호에서 시작하게 한다. 
            따라서 증가 효과는 물론, 감소 효과까지 보여지게 만든다.
          */

          /* 기존 값 - 새로운 값에 대한 새로운 증감값 */
          const newRateAmount: number = (countNum - helperNum) * rate;

          /* console.log(
            '다를 때 받은 숫자 => ',
            helperNum,
            '\n다를 때 기존숫자 => ',
            countNum,
            '\n다를 때 증값 => ',
            newRateAmount
          ); */

          calcNum = countNum;
          rateAmount = Math.sign(newRateAmount) > -1 ? newRateAmount : -newRateAmount;
        }

        const count = setInterval(() => {
          if (helperNum > calcNum) {
            /* 받아온 숫자가 현재 숫자보다 더 클 때, 증가시켜준다. */
            calcNum = calcNum + rateAmount;
          } else {
            /* 받아온 숫자가 현재 숫자보다 더 작을 때, 감소시켜준다. */
            calcNum = calcNum - rateAmount;
          }

          const setNumber: number = Math.round(calcNum);
          if (helperNum === setNumber) {
            // 계산이 끝날 때
            setCountNum(setNumber);
            clearInterval(count);

            return false;
          } else {
            setCountNum(calcNum);
          }
        }, duration);
      };

      processCount();
    }
  }, [helperNum]);

  return (
    <>
      {needComma
        ? addComma(Math.round(Math.sign(newNum) > -1 ? countNum : -countNum), needZero)
        : Math.round(Math.sign(newNum) > -1 ? countNum : -countNum)}
    </>
  );
}

/**
 *  숫자 카운트 효과가 있는 컴포넌트
 * @param {number} newNum 새로 받은 숫자 (기본값 0)
 * @param {boolean} needComma 세자리 숫자마다 콤마 필요 여부 (기본값 false)
 * @param {boolean} needZero 0의 숫자표현 필요 여부 (default: false)
 *  */
export default React.memo(CountNumber);
